import React from 'react'

import { TRACKING_MAPPING } from '@js/common/constants'

import Icon from '@f/elements/Icon'

const FormRadio = ({
  formElement,
  radioValue = null,
  defaultChecked = false,
  name,
  theme = 'basic',
  label,
  labelClassName = null,
  icon = null,
  iconClassName = null,
  className = null,
  onChange = null,
  onFocus = () => {},
  onBlur = () => {},
  inputProps = null,
  wtData = {},
  ...props
}) => {
  const onInputChange = event => {
    window._wt({
      category: 'radiobutton',
      action: 'click',
      values: [
        {
          type:
            TRACKING_MAPPING[name] && TRACKING_MAPPING[name].label
              ? TRACKING_MAPPING[name].label
              : name,
          value: radioValue
        }
      ],
      ...(wtData['radiobutton'] ? wtData['radiobutton'] : {})
    })

    if (onChange) {
      onChange(event)
    }
  }

  const onInputBlur = event => {
    if (onBlur) {
      onBlur(event)
    }
  }

  const onInputFocus = event => {
    if (onFocus) {
      onFocus(event)
    }
  }

  let finalLabelClassNames
  let formClassNames = ''

  switch (theme) {
    case 'basic':
      finalLabelClassNames =
        '[ f-d-inbl f-t-mini f-m-h-010 f-c-fo-pri f-t-centre ]'
      break

    case 'basic-block':
      finalLabelClassNames =
        '[ f-d-inbl f-m-a-010 f-t-body f-c-fo-pri f-t-centre ]'
      break

    case 'form':
      finalLabelClassNames = `[ f-d-bl f-t-body f-t-centre ${
        defaultChecked ? 'f-c-fo-pri' : 'f-c-fo-pri'
      } ]`
      formClassNames = `${defaultChecked ? 'f-c-bo-pri' : 'f-c-bo-neu025'}`
      break

    default:
      finalLabelClassNames =
        '[ f-d-bl f-m-a-010 f-t-body f-c-fo-pri f-t-centre ]'
  }

  if (labelClassName) {
    finalLabelClassNames = labelClassName
  }

  return (
    <label
      className={`FormRadio-wrapper FormRadio-wrapper-${theme} ${formClassNames} ${
        className ? className : ''
      } ${defaultChecked === true ? 'is-checked' : ''}
      ${
        defaultChecked === true && (/block/.test(theme) || /form/.test(theme))
          ? 'f-c-bo-pri'
          : 'f-c-bo-neu025'
      }`}
      {...props}>
      <input
        type='radio'
        className='FormRadio'
        checked={defaultChecked}
        name={name}
        value={radioValue}
        onChange={onInputChange}
        onFocus={onInputFocus}
        onBlur={onInputBlur}
        {...inputProps}
      />
      {/basic/.test(theme) && (
        <span
          className={`[ ${
            theme === 'basic-block' ? 'f-m-v-010' : 'f-m-v-005'
          } ] FormRadio-dot ${defaultChecked === true ? 'is-checked' : ''}`}
        />
      )}
      {icon ? (
        <span className='[ f-d-bl f-t-centre ]'>
          <Icon icon={icon} className={iconClassName} />
        </span>
      ) : (
        ''
      )}
      {label ? <span className={`${finalLabelClassNames}`}>{label}</span> : ''}
    </label>
  )
}

export default FormRadio
